/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NormativityControllerGetCatalogs200ResponseDataAreasInner } from './normativityControllerGetCatalogs200ResponseDataAreasInner';
import { NormativityControllerGetCatalogs200ResponseDataCompaniesInner } from './normativityControllerGetCatalogs200ResponseDataCompaniesInner';
import { NormativityControllerGetCatalogs200ResponseDataOwnersInner } from './normativityControllerGetCatalogs200ResponseDataOwnersInner';
import { NormativityControllerGetCatalogs200ResponseDataTypesInner } from './normativityControllerGetCatalogs200ResponseDataTypesInner';


export interface NormativityControllerGetCatalogs200ResponseData { 
    companies?: Array<NormativityControllerGetCatalogs200ResponseDataCompaniesInner>;
    areas?: Array<NormativityControllerGetCatalogs200ResponseDataAreasInner>;
    types?: Array<NormativityControllerGetCatalogs200ResponseDataTypesInner>;
    owners?: Array<NormativityControllerGetCatalogs200ResponseDataOwnersInner>;
    documentStatuses?: Array<NormativityControllerGetCatalogs200ResponseDataCompaniesInner>;
    versionStatuses?: Array<NormativityControllerGetCatalogs200ResponseDataCompaniesInner>;
    /**
     * Empresa a la que aplica normatividad (variable de entorno). Con valor, el cliente la preselecciona y deja el campo fijo; null, el campo vuelve a ser elegible
     */
    defaultCompanyId?: string | null;
}

